class AppURL {
     // static BaseURL = "http://127.0.0.1:8000/api"
     static BaseURL = "https://navana.softenginebd.com/api";
     static AllData = this.BaseURL + "/offline-data";
     static SyncData = this.BaseURL + "/offline-sync";
     static UserLogin = this.BaseURL + "/login"
     static UserRegister = this.BaseURL + "/register"
     static UserData = this.BaseURL + "/user"
     static UserForgetPassword = this.BaseURL + "/forgot-password"
     static UserResetPassword = this.BaseURL + "/reset-password"
     static getsupplier = this.BaseURL + "/all/supplier"
     static getsupplierreport = this.BaseURL + "/all/supplier/report"
     static addSupplier = this.BaseURL + "/store/supplier"
     static editSupplier = this.BaseURL + "/edit/supplier";
     static updateSupplier = this.BaseURL + "/update/supplier"
     static deleteSupplier = this.BaseURL + "/delete/supplier";
     static allGroup = this.BaseURL + "/all/groups";
    

}

export default AppURL
